angular.module('duplicatedCar', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/duplicated-car/duplicated-car.module.js